export default {
  setStoriesCompilationState(state, payload) {
    state.compilation = payload;
  },
  mutateStoriesCompilationState(state, payload) {
    if (state.compilation) {
      state.compilation = {...state.compilation, ...payload};
    }
  },
  setStoriesCompilationLoadingState(state, payload) {
    state.compilationLoading = payload;
  },
  setStoriesCompilationsListState(state, payload) {
    state.compilationsList = payload;
  },
  setStoriesCompilationsListLoadingState(state, loading) {
    state.compilationsListLoading = loading;
  },
  setUpdateStoryLoadingState(state, payload) {
    state.updateStoryLoading = payload;
  },
  setUpdateStoriesCompilationLoadingState(state, payload) {
    state.updateCompilationLoading = payload;
  },
  setStoriesListState(state, payload) {
    state.storiesList = payload;
  },
  appendStoriesListState(state, payload) {
    const current = state.storiesList || [];
    state.storiesList = [...current, ...payload];
  },
  setStoriesMetaState(state, meta) {
    state.storiesMeta = meta;
  },
  setStoriesLoadingState(state, loading) {
    state.storiesLoading = loading;
  },
  setStoriesOptionsState(state, options) {
    state.storiesOptions = options;
  },
  setStoriesByPersonIdState(state, {id, stories}) {
    state.storiesByPersonId = {...state.storiesByPersonId, [id]: stories || []};
  },
  setStoriesMetaByPersonIdState(state, {id, meta}) {
    state.storiesMetaByPersonId = {...state.storiesMetaByPersonId, [id]: meta || {}};
  },
  setStoriesLoadingByPersonIdState(state, {id, loading}) {
    state.storiesLoadingByPersonId = {...state.storiesLoadingByPersonId, [id]: loading};
  },

  setStoryState(state, payload) {
    state.story = payload;
  },
  mutateStoryState(state, payload) {
    state.story = {
      ...state.story,
      ...payload,
    };
  },
  setStoryLoadingState(state, loading) {
    state.storyLoading = loading;
  },
  setStoryPinLoadingState(state, loading) {
    state.storyPinLoading = loading;
  },
  setStoryCreateLoadingState(state, payload) {
    state.storyCreateLoading = payload;
  },
  setStoryCreateInitDataState(state, payload) {
    state.storyCreateInitData = payload;
  },
};
